import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

const APP_NAME = "NY 2027 Countdown";
const TARGET_DATE = new Date("2027-01-01T00:00:00Z").getTime();

function App() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      const distance = TARGET_DATE - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const containerStyle: React.CSSProperties = {
    fontFamily: "system-ui, -apple-system, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#0a0a0a",
    color: "#ffffff",
    margin: 0,
    padding: "2rem",
    textAlign: "center",
  };

  const gridStyle: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "1.5rem",
    marginTop: "2rem",
  };

  const unitStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.5rem",
    backgroundColor: "#1a1a1a",
    borderRadius: "1rem",
    minWidth: "120px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
    border: "1px solid #333",
  };

  const valueStyle: React.CSSProperties = {
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    fontVariantNumeric: "tabular-nums",
  };

  const labelStyle: React.CSSProperties = {
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "#888",
  };

  return (
    <main style={containerStyle}>
      <h1 style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>{APP_NAME}</h1>
      <p style={{ color: "#888", fontSize: "1.1rem" }}>Counting down to the new year!</p>

      <div style={gridStyle}>
        <div style={unitStyle}>
          <div style={valueStyle}>{timeLeft.days}</div>
          <div style={labelStyle}>Days</div>
        </div>
        <div style={unitStyle}>
          <div style={valueStyle}>{timeLeft.hours}</div>
          <div style={labelStyle}>Hours</div>
        </div>
        <div style={unitStyle}>
          <div style={valueStyle}>{timeLeft.minutes}</div>
          <div style={labelStyle}>Minutes</div>
        </div>
        <div style={unitStyle}>
          <div style={valueStyle}>{timeLeft.seconds}</div>
          <div style={labelStyle}>Seconds</div>
        </div>
      </div>
    </main>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
